/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _objectWithoutProperties } from '../_chunks/dep-e68fd68c.mjs';
import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, ref, computed, createVNode, mergeProps } from 'vue';
import baseTableProps from './base-table-props.mjs';
import primaryTableProps from './primary-table-props.mjs';
import enhancedTableProps from './enhanced-table-props.mjs';
import _PrimaryTable from './primary-table.mjs';
import useTreeData from './hooks/useTreeData.mjs';
import useTreeSelect from './hooks/useTreeSelect.mjs';
import '../_chunks/dep-6d14fb16.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-0c515b62.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-f1423dd2.mjs';
import '../_chunks/dep-efb50e88.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-10db0930.mjs';
import '../_chunks/dep-ad0cc3b4.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-72359af2.mjs';
import '../_chunks/dep-e769aafd.mjs';
import './base-table.mjs';
import '../_chunks/dep-32e8a48d.mjs';
import '../_chunks/dep-759eacca.mjs';
import '../_chunks/dep-544fb8fd.mjs';
import './hooks/useTableHeader.mjs';
import '../_chunks/dep-dcf624da.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import '../_chunks/dep-2684fd15.mjs';
import './hooks/useMultiHeader.mjs';
import './hooks/useClassName.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';
import './ellipsis.mjs';
import '../_chunks/dep-241fdd8c.mjs';
import '../_chunks/dep-050b3eb2.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../tooltip/index.mjs';
import '../tooltip/tooltip.mjs';
import '../tooltip/props.mjs';
import '../popup/props.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../_common/js/utils/set-style.mjs';
import '../popup/container.mjs';
import '../_chunks/dep-8c39d78a.mjs';
import '../hooks/useVModel.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../popup/type.mjs';
import '../hooks/tnode.mjs';
import '../tooltip/util.mjs';
import '../tooltip/type.mjs';
import './hooks/useColumnResize.mjs';
import '../_chunks/dep-869cd310.mjs';
import '../_common/js/table/set-column-width-by-drag.mjs';
import '../_common/js/table/utils.mjs';
import '../_common/js/table/recalculate-column-width.mjs';
import './hooks/useFixed.mjs';
import '../_common/js/log/index.mjs';
import '../_common/js/log/log.mjs';
import '../_common/js/utils/getScrollbarWidth.mjs';
import '../_common/js/utils/helper.mjs';
import './hooks/usePagination.mjs';
import '../pagination/index.mjs';
import '../pagination/pagination.mjs';
import 'tdesign-icons-vue-next';
import '../hooks/useGlobalIcon.mjs';
import '../input-number/index.mjs';
import '../input-number/input-number.mjs';
import '../button/index.mjs';
import '../button/button.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../utils/transfer-dom.mjs';
import '../loading/props.mjs';
import '../loading/type.mjs';
import '../button/props.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../utils/set-style.mjs';
import '../form/hooks.mjs';
import '../button/type.mjs';
import '../input/index.mjs';
import '../input/input.mjs';
import '../input/props.mjs';
import '../input/useInput.mjs';
import '../utils/helper.mjs';
import '../form/const.mjs';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../input/useInputEventHandler.mjs';
import '../input/useInputWidth.mjs';
import '../input/input-group.mjs';
import '../input/type.mjs';
import '../input-number/props.mjs';
import '../input-number/useInputNumber.mjs';
import '../_common/js/input-number/number.mjs';
import '../_common/js/input-number/large-number.mjs';
import '../input-number/type.mjs';
import '../select/index.mjs';
import '../select/select.mjs';
import '../_chunks/dep-ef911020.mjs';
import 'lodash';
import '../common-components/fake-arrow.mjs';
import '../select-input/index.mjs';
import '../select-input/select-input.mjs';
import '../select-input/props.mjs';
import '../select-input/useSingle.mjs';
import '../select-input/useMultiple.mjs';
import '../tag-input/index.mjs';
import '../tag-input/tag-input.mjs';
import '../tag-input/props.mjs';
import '../tag-input/hooks/useTagScroll.mjs';
import '../tag-input/useTagList.mjs';
import '../tag/index.mjs';
import '../tag/tag.mjs';
import '../tag/props.mjs';
import '../tag/check-tag.mjs';
import '../tag/check-tag-props.mjs';
import '../tag/type.mjs';
import '../tag-input/hooks/useHover.mjs';
import '../tag-input/hooks/useDragSorter.mjs';
import '../tag-input/type.mjs';
import '../select-input/useOverlayInnerStyle.mjs';
import '../select-input/type.mjs';
import '../select/select-panel.mjs';
import '../select/option.mjs';
import '../select/option-props.mjs';
import '../checkbox/index.mjs';
import '../checkbox/checkbox.mjs';
import '../checkbox/props.mjs';
import '../checkbox/constants.mjs';
import '../checkbox/group.mjs';
import '../_chunks/dep-2ca0e5ff.mjs';
import '../_chunks/dep-c5bb3a66.mjs';
import '../checkbox/checkbox-group-props.mjs';
import '../checkbox/type.mjs';
import '../select/helper.mjs';
import '../select/optionGroup.mjs';
import '../select/option-group-props.mjs';
import '../select/props.mjs';
import '../select/hooks/usePanelVirtualScroll.mjs';
import '../select/hooks/useSelectOptions.mjs';
import '../select/type.mjs';
import '../input-adornment/index.mjs';
import '../input-adornment/input-adornment.mjs';
import '../input-adornment/props.mjs';
import '../input-adornment/type.mjs';
import '../pagination/props.mjs';
import '../pagination/usePaginationClasses.mjs';
import '../pagination/useMoreAction.mjs';
import '../pagination/type.mjs';
import './hooks/useAffix.mjs';
import './tbody.mjs';
import './tr.mjs';
import './utils.mjs';
import './hooks/useLazyLoad.mjs';
import '../_common/js/utils/observe.mjs';
import './hooks/useRowspanAndColspan.mjs';
import './hooks/useStyle.mjs';
import '../affix/index.mjs';
import '../affix/affix.mjs';
import '../_chunks/dep-9262ea29.mjs';
import '../affix/props.mjs';
import '../affix/type.mjs';
import './thead.mjs';
import './tfoot.mjs';
import './hooks/useColumnController.mjs';
import '../dialog/plugin.mjs';
import '../dialog/dialog.mjs';
import '../dialog/props.mjs';
import '../dialog/hooks.mjs';
import '../dialog/stack.mjs';
import './hooks/useRowExpand.mjs';
import './hooks/useRowSelect.mjs';
import '../radio/index.mjs';
import '../radio/radio.mjs';
import '../radio/props.mjs';
import '../radio/constants.mjs';
import '../radio/group.mjs';
import '../_chunks/dep-88e40e6a.mjs';
import '../radio/radio-group-props.mjs';
import '../radio/radio-button.mjs';
import '../radio/type.mjs';
import './hooks/useSorter.mjs';
import './sorter-button.mjs';
import './hooks/useFilter.mjs';
import './filter-controller.mjs';
import './hooks/useDragSort.mjs';
import 'sortablejs';
import '../_common/js/utils/swapDragArrayElement.mjs';
import './hooks/useAsyncLoading.mjs';
import './editable-cell.mjs';
import '../_chunks/dep-808dde7b.mjs';
import '../form/form-model.mjs';
import './hooks/useEditableRow.mjs';
import '../_common/js/table/tree-store.mjs';
import '../_chunks/dep-84a9ab7d.mjs';

var _excluded = ["store", "dataSource", "formatTreeColumn", "swapData"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _EnhancedTable = defineComponent({
  name: "TEnhancedTable",
  props: _objectSpread(_objectSpread(_objectSpread({}, baseTableProps), primaryTableProps), enhancedTableProps),
  setup: function setup(props, context) {
    var _useTreeData = useTreeData(props, context),
        store = _useTreeData.store,
        dataSource = _useTreeData.dataSource,
        formatTreeColumn = _useTreeData.formatTreeColumn,
        swapData = _useTreeData.swapData,
        treeInstanceFunctions = _objectWithoutProperties(_useTreeData, _excluded);

    var treeDataMap = ref(store.value.treeDataMap);

    var _useTreeSelect = useTreeSelect(props, treeDataMap),
        tIndeterminateSelectedRowKeys = _useTreeSelect.tIndeterminateSelectedRowKeys,
        onInnerSelectChange = _useTreeSelect.onInnerSelectChange;

    var getColumns = function getColumns(columns) {
      var arr = [];

      for (var i = 0, len = columns.length; i < len; i++) {
        var _item$children, _item$children2;

        var item = _objectSpread({}, columns[i]);

        item = formatTreeColumn(item);

        if ((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
          item.children = getColumns(item.children);
        }

        if (!item.children || (_item$children2 = item.children) !== null && _item$children2 !== void 0 && _item$children2.length) {
          arr.push(item);
        }
      }

      return arr;
    };

    var tColumns = computed(function () {
      var isTreeData = !props.tree || !Object.keys(props.tree).length;
      return isTreeData ? props.columns : getColumns(props.columns);
    });

    var onDragSortChange = function onDragSortChange(params) {
      var _props$onDragSort;

      if (props.beforeDragSort && !props.beforeDragSort(params)) return;
      swapData({
        current: params.current,
        target: params.target,
        currentIndex: params.currentIndex,
        targetIndex: params.targetIndex
      });
      (_props$onDragSort = props.onDragSort) === null || _props$onDragSort === void 0 ? void 0 : _props$onDragSort.call(props, params);
    };

    return _objectSpread({
      store: store,
      dataSource: dataSource,
      tColumns: tColumns,
      tIndeterminateSelectedRowKeys: tIndeterminateSelectedRowKeys,
      onDragSortChange: onDragSortChange,
      onInnerSelectChange: onInnerSelectChange
    }, treeInstanceFunctions);
  },
  render: function render() {
    var props = _objectSpread(_objectSpread({}, this.$props), {}, {
      data: this.dataSource,
      columns: this.tColumns,
      indeterminateSelectedRowKeys: this.tIndeterminateSelectedRowKeys,
      disableDataPage: Boolean(this.tree && Object.keys(this.tree).length),
      onSelectChange: this.onInnerSelectChange,
      onDragSort: this.onDragSortChange
    });

    return createVNode(_PrimaryTable, mergeProps(props, this.$attrs), this.$slots);
  }
});

export { _EnhancedTable as default };
//# sourceMappingURL=enhanced-table.mjs.map
